interface AssociateContractReq {
  contracts: ContractInput[]
}

interface ContractInput {
  integraContractCode: string,
  contractId: string,
  token: string,
  attachments?: Attachment[]
}

interface Attachment {
  type: AttachmentType,
  data: string
}

enum AttachmentType {
  VERBAL
}

export class Contracts {
  static makeData(values: any): AssociateContractReq {
    return {
      contracts: values.map((contract: ContractInput) => {
        return contract.attachments ? {
          integraContractCode: contract.integraContractCode,
          contractId: contract.contractId,
          token: contract.token,
          attachments: [
            {
              type: contract.attachments[0].type,
              data: contract.attachments[0].data
            }
          ]
        } : {
          integraContractCode: contract.integraContractCode,
          contractId: contract.contractId,
          token: contract.token
        }
      })

    } as AssociateContractReq
  }
}

// interface SearchContractReq {
//     // contractId?: string,
//     integraContractCode: string,
//     invoiceNumber: string
// }

// export class SearchContracts {
//     static makeData( integraContractCode, invoiceNumber) {
//         return {
//             integraContractCode: integraContractCode,
//             // integraContractCode: integraContractCode,
//             invoiceNumber: invoiceNumber
//         } as SearchContractReq
//     }
// }
